import { useEffect } from 'react'

export function useFeatureImageWidth({ phoneImageRef, phoneUrlRef, netWorkRef, distributionRef, cardRef }) {
  useEffect(() => {
    const handleImageWidth = () => {
      // 因為 phone image 的 width 隨裝置高度而動態改變
      // 所以 onResize 時 image 上物件的 width 都要調整
      phoneUrlRef.current.style.width = `${phoneImageRef.current.offsetWidth}px`
      netWorkRef.current.style.width = `${phoneImageRef.current.offsetWidth}px`
      distributionRef.current.style.width = `${phoneImageRef.current.offsetWidth}px`
      cardRef.current.style.width = `${phoneImageRef.current.offsetWidth}px`
    }

    handleImageWidth()

    window.addEventListener('resize', handleImageWidth)

    return () => {
      window.removeEventListener('resize', handleImageWidth)
    }
  }, [phoneImageRef, phoneUrlRef, netWorkRef, distributionRef, cardRef])
}
